import HotelsPage from '@/modules/hotels';

export const Component = () => {
  return <HotelsPage />;
};
